import React, { useEffect, useRef, useState } from "react";
import tw from "tailwind-styled-components";
import { Formik, Field, Form } from "formik";
import { MdClose, MdEdit } from "react-icons/md";
import {
    FaCheckCircle,
    FaMoneyBillWave,
} from "react-icons/fa";
import {
    InputGroup,
    FieldWrappers,
    Label,
    SubmitBtn,
    SideCancelBtn,
    Wrapper,
    ScrollableContent,
    ActionSection,
    Summary,
    SummaryTitle,
    SummaryRow,
    SummaryLabel,
    SummaryValue,
    RupeeIcon,
} from "../../Styles/InputStyles";
import { toast } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { tranfer_payment_method } from "../../../Config";
import SelectOptionModal from "../../SelectOptionModal";
import SelectItemModal from "../../SelectItemModal";
import CategoryCard from "../../CategoryCard";

const MarkAsPaidOnlineModal = ({
    handleClose,
    onlineMarkAsPaidMutate,
    onlineMarkAsPaidLoading,
    selectedData,
    selectedExpense,
    availableAmount = 300,
    maxTransLimit
}) => {
    const formikRef = useRef(null);
    const [height, setHeight] = useState(window.innerHeight);
    const [isMethodModalOpen, setIsMethodModalOpen] = useState(false);
    const [isAccountModalOpen, setIsAccountModalOpen] = useState(false);
    const [selectedBeneficiary, setSelectedBeneficiary] = useState(null);

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight);
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const getExpenseId = () => {
        return selectedExpense?.id || selectedData?.id;
    };

    const getExpenseType = () => {
        return selectedExpense?.type || selectedData?.type || 2;
    };

    const getBalance = () => {
        return selectedExpense?.balance || selectedData?.balance || 0;
    };

    const getAccounts = () => {
        return selectedData?.accounts || [];
    };

    const initialValues = {
        selectedAmount: getBalance(),
        remarks: selectedData?.description || "",
        paymentType: 0,
        transferMethod: 2,
        beneficiaryId: null,
        accountNumber: "",
        ifsc: "",
        upiId: "",
        beneficiaryName: "",
        beneficiaryMobile: "",
    };

    const paymentTypes = [
        {
            label: "Full Payment",
            value: 0,
            icon: <FaCheckCircle className="w-6 h-6 text-green-500" />,
        },
        {
            label: "Partial Payment",
            value: 1,
            icon: <FaMoneyBillWave className="w-6 h-6 text-blue-500" />,
        },
    ];

    const handleBeneficiarySelect = (selectedItem) => {
        setSelectedBeneficiary(selectedItem);

        if (formikRef.current) {
            formikRef.current.setFieldValue("beneficiaryId", selectedItem?.id);
            formikRef.current.setFieldValue("accountNumber", selectedItem?.accountNum || "");
            formikRef.current.setFieldValue("ifsc", selectedItem?.ifsc || "");
            formikRef.current.setFieldValue("upiId", selectedItem?.upiId || "");
            formikRef.current.setFieldValue("beneficiaryName", selectedItem?.holderName || selectedItem?.name || "");
            formikRef.current.setFieldValue("beneficiaryMobile", selectedItem?.mobile || "");
        }
        setIsAccountModalOpen(false);
    };

    const getSelectedBeneficiaryDisplay = () => {
        if (selectedBeneficiary) {
            return {
                label: selectedBeneficiary.holderName || selectedBeneficiary.name,
                value: selectedBeneficiary.id,
                subtitle: selectedBeneficiary.mobile
            };
        }
        return null;
    };

    const getBeneficiaryDescription = (beneficiary) => {
        const details = [];
        if (beneficiary?.accountNum) {
            details.push(`Account No: ${beneficiary.accountNum}`);
        }
        if (beneficiary?.ifsc) {
            details.push(`IFSC: ${beneficiary.ifsc}`);
        }
        return details.join(" | ");
    };

    const handleSubmit = (values, formikHelpers) => {
        if (values.paymentType === undefined || values.paymentType === null) {
            toast.error("Payment type is required");
            return;
        }

        if (!values.beneficiaryId) {
            toast.error("Please select an account");
            return;
        }
        if (Number(values.selectedAmount) > availableAmount) {
            toast.error("Amount cannot exceed available amount");
            return;
        }
        if (Number(maxTransLimit) > 0 && Number(values.selectedAmount) > Number(maxTransLimit)) {
            toast.error(
                `Amount cannot exceed ₹${Number(maxTransLimit)}`
            );
            return;
        }
        if (values.paymentType !== 0) {
            // if (!values.selectedAmount) {
            //     toast.error("Amount is required");
            //     return;
            // }
            if (!values.selectedAmount || Number(values.selectedAmount) <= 0) {
                toast.error("Please enter a valid amount greater than 0");
                return;
            }
            if (Number(values.selectedAmount) > getBalance()) {
                toast.error("Amount cannot exceed total dues for partial payment");
                return;
            }

        }

        const amountToSend = values.paymentType === 0 ? getBalance() : Number(values.selectedAmount);

        // Prepare API payload with safe access
        const payload = {
            expenseId: getExpenseId(),
            // landlordId: selectedData?.landlordId,
            // propId: selectedData?.propId,
            payoutUserType: selectedData?.paidToUserType,
            payoutUserId: selectedData?.paidTo,
            amount: amountToSend,
            paymentType: values.paymentType,
            remarks: values.remarks || "",
            method: values.transferMethod || 2,
            type: getExpenseType(),
            beneficiaryId: values.beneficiaryId,
            accountNumber: values.accountNumber,
            ifsc: values.ifsc,
            upiId: values.upiId,
            beneficiaryName: values.beneficiaryName,
            beneficiaryMobile: values.beneficiaryMobile,
        };

        if (!payload.expenseId) {
            toast.error("Expense ID is missing");
            return;
        }
        if (!payload.payoutUserType || !payload.payoutUserId) {
            toast.error("Please select a recipient");
            return;
        }

        onlineMarkAsPaidMutate(payload);
    };

    const getCurrentMethodLabel = (transferMethodValue) => {
        const selectedMethod = tranfer_payment_method.find(
            (method) => method.value === transferMethodValue
        );
        return selectedMethod ? selectedMethod.label : "Select transfer method";
    };

    const transferMethodOptions = tranfer_payment_method.map((method) => ({
        label: method.label,
        value: method.value,
    }));

    const formattedAccounts = getAccounts().map(account => ({
        ...account,
        displayName: account.holderName || account.name,
        displayDescription: `${account.accountNum ? `AC: ${account.accountNum}` : ''} ${account.ifsc ? `IFSC: ${account.ifsc}` : ''}`.trim()
    }));

    return (
        <Container style={{ height: `${height}px`, overflow: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <Header>
                <h1 className="text-white text-lg font-medium">Pay Expense</h1>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </Header>

            <ProfileSection className="flex justify-between">
                <UserInfo>
                    <span className="font-medium mb-0 text-lg">
                        {selectedData?.paidToName || "N/A"}
                    </span>
                    <span className="text-sm text-gray-600">#{selectedData?.paidToMobile || "N/A"}</span>
                </UserInfo>
                <div className="flex flex-col gap-0">
                    <span className='text-gray-500 text-sm'>Balance</span>
                    <span className='text-xl font-semibold text-gray-700'>₹{getBalance()}</span>
                </div>
            </ProfileSection>

            {selectedData?.lastPaidOn && (
                <ProfileSection className="flex justify-between bg-blue-50 py-1.5 text-xs font-medium text-gray-600">
                    <div>Last Rent Paid On:</div>
                    <div>{moment(selectedData?.lastPaidOn).format("DD MMM YYYY")}</div>
                </ProfileSection>
            )}

            <div className="flex flex-col justify-between flex-1">
                <Formik
                    innerRef={formikRef}
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    enableReinitialize
                >
                    {({ setFieldValue, values, resetForm, handleSubmit, errors, touched }) => {
                        const handleTransferMethodSelect = (selectedValue) => {
                            setFieldValue("transferMethod", selectedValue);
                        };

                        const handlePaymentTypeChange = (paymentTypeValue) => {
                            setFieldValue("paymentType", paymentTypeValue);
                            if (paymentTypeValue === 0) {
                                setFieldValue("selectedAmount", getBalance());
                            } else {
                                setFieldValue("selectedAmount", "");
                            }
                        };

                        return (
                            <Form onSubmit={handleSubmit} className="flex flex-col flex-1">
                                <ScrollableContent className="flex-1">
                                    <Wrapper className="px-6">
                                        {/* Payment Type Selection */}
                                        <InputGroup>
                                            <Label htmlFor="paymentType">Payment Type *</Label>
                                            <div className="grid grid-cols-3 gap-2">
                                                {paymentTypes.map((option) => (
                                                    <OptionCard
                                                        key={option.value}
                                                        type="button"
                                                        isselected={(values.paymentType === option.value).toString()}
                                                        onClick={() => handlePaymentTypeChange(option.value)}
                                                    >
                                                        <span className="text-sm">{option.label}</span>
                                                    </OptionCard>
                                                ))}
                                            </div>
                                        </InputGroup>

                                        {/* Beneficiary/Account Selection */}
                                        <InputGroup>
                                            <Label htmlFor="beneficiaryName">Select Account *</Label>
                                            <CategoryCard
                                                title="Beneficiary Account"
                                                selectedCategory={getSelectedBeneficiaryDisplay()}
                                                onClick={() => setIsAccountModalOpen(true)}
                                            />
                                            {errors.beneficiaryId && touched.beneficiaryId && (
                                                <ErrorText>{errors.beneficiaryId}</ErrorText>
                                            )}
                                            {selectedBeneficiary && (
                                                <div className="mt-2 flex flex-wrap gap-2">
                                                    {/* Account Number */}
                                                    {selectedBeneficiary?.accountNum && (
                                                        <span className="rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-700">
                                                            🏦 ••••{selectedBeneficiary.accountNum.slice(-4)}
                                                        </span>
                                                    )}

                                                    {/* IFSC */}
                                                    {selectedBeneficiary?.ifsc && (
                                                        <span className="rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-700">
                                                            {selectedBeneficiary.ifsc}
                                                        </span>
                                                    )}

                                                    {/* Last Payment */}
                                                    {selectedBeneficiary?.lastPaidDate && (
                                                        <span className="rounded-full bg-blue-50 px-3 py-1 text-xs font-medium text-blue-700">
                                                            ₹{Number(
                                                                selectedBeneficiary?.lastPaidAmount || 0,
                                                            )}
                                                            {" • "}
                                                            {moment(selectedBeneficiary.lastPaidDate).format(
                                                                "DD MMM, YY",
                                                            )}
                                                        </span>
                                                    )}

                                                    {/* Payment Source */}
                                                    {selectedBeneficiary?.lastPaidDate && (
                                                        <span
                                                            className={`rounded-full px-3 py-1 text-xs font-medium ${selectedBeneficiary?.isLastPaymentOnline
                                                                ? "bg-green-50 text-green-700"
                                                                : "bg-amber-50 text-amber-700"
                                                                }`}
                                                        >
                                                            {selectedBeneficiary?.isLastPaymentOnline
                                                                ? "🟢 Kipinn"
                                                                : "🟠 Offline"}
                                                        </span>
                                                    )}
                                                </div>
                                            )}

                                        </InputGroup>

                                        {/* Transfer Method Selection */}
                                        <InputGroup>
                                            <Label htmlFor="transferMethod">Transfer Method *</Label>
                                            <FieldWrappers onClick={() => setIsMethodModalOpen(true)}>
                                                <Field
                                                    type="text"
                                                    name="transferMethodDisplay"
                                                    id="transferMethodDisplay"
                                                    autoComplete="off"
                                                    readOnly
                                                    value={getCurrentMethodLabel(values.transferMethod)}
                                                    className="w-full border-none outline-none bg-transparent cursor-pointer"
                                                    placeholder="Select transfer method"
                                                />
                                                <MdEdit className="w-4 h-4 text-gray-400 hover:text-gray-600 transition-colors duration-200 flex-shrink-0 mr-2" />
                                            </FieldWrappers>
                                        </InputGroup>


                                        {/* <div
                                            className={`rounded-lg px-4 py-3 border ${Number(availableAmount) < 100 ? "bg-red-50 border-red-100" : "bg-green-50 border-green-100"}`}
                                        >
                                            <div className="flex items-center justify-between">
                                                <p className={`text-sm font-medium ${availableAmount < 100 ? "text-red-700" : "text-green-700"}`}>
                                                    Available Balance
                                                </p>

                                                <p className={`text-lg font-semibold ${availableAmount < 100 ? "text-red-800" : "text-green-800"}`}>
                                                    ₹{Number(availableAmount || 0).toLocaleString("en-IN")}
                                                </p>
                                            </div>

                                            <p className="text-xs text-green-600 mt-1">
                                                Maximum transfer limit is {Number(availableAmount) > 500000 ? '₹5,00,000' : Number(availableAmount)}
                                            </p>

                                            {values.method === 3 && (
                                                <p className="text-xs text-orange-600 mt-1">
                                                    RTGS minimum amount is ₹2,00,000
                                                </p>
                                            )}
                                        </div> */}
                                        {/* Amount Selection */}
                                        {(values.paymentType === 0 || values.paymentType === 1) && (
                                            <InputGroup>
                                                <div className="flex justify-between items-center mb-1">
                                                    <Label htmlFor="selectedAmount">
                                                        {values.paymentType === 0 ? "Amount" : "Partial Amount"} *
                                                    </Label>
                                                    <span className="text-xs font-medium text-green-600">
                                                        Balance ₹{Number(availableAmount).toLocaleString("en-IN")}
                                                    </span>
                                                </div>
                                                <FieldWrappers className="w-full">
                                                    <RupeeIcon />
                                                    <Field
                                                        name="selectedAmount"
                                                        type="number"
                                                        disabled={values.paymentType === 0}
                                                        placeholder="Enter Amount"
                                                        className="w-full pl-5"
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            setFieldValue("selectedAmount", value);
                                                        }}
                                                    />
                                                </FieldWrappers>
                                            </InputGroup>
                                        )}

                                        {/* Remarks */}
                                        <InputGroup>
                                            <Label htmlFor="remarks">Remarks</Label>
                                            <FieldWrapper>
                                                <Field
                                                    as={Textarea}
                                                    id="remarks"
                                                    name="remarks"
                                                    rows={4}
                                                    maxLength={500}
                                                    placeholder="Write your remark here..."
                                                />
                                            </FieldWrapper>
                                        </InputGroup>

                                        {/* Summary */}
                                        <Summary>
                                            <SummaryTitle>Summary</SummaryTitle>
                                            <SummaryRow>
                                                <SummaryLabel>Amount selected</SummaryLabel>
                                                <SummaryValue>
                                                    ₹{values.paymentType === 0
                                                        ? getBalance()
                                                        : values.selectedAmount || 0}
                                                </SummaryValue>
                                            </SummaryRow>
                                            <SummaryRow>
                                                <SummaryLabel>Amount outstanding</SummaryLabel>
                                                <SummaryValue>
                                                    ₹{values.paymentType === 0
                                                        ? 0
                                                        : values.selectedAmount
                                                            ? getBalance() - Number(values.selectedAmount)
                                                            : getBalance()}
                                                </SummaryValue>
                                            </SummaryRow>
                                        </Summary>
                                    </Wrapper>
                                </ScrollableContent>

                                <ActionSection>
                                    <SideCancelBtn
                                        type="button"
                                        onClick={() => {
                                            resetForm();
                                            setSelectedBeneficiary(null);
                                            handleClose();
                                        }}
                                    >
                                        Cancel
                                    </SideCancelBtn>
                                    <SubmitBtn
                                        type="submit"
                                        disabled={onlineMarkAsPaidLoading}
                                    >
                                        {onlineMarkAsPaidLoading ? "Processing..." : "Pay"}
                                    </SubmitBtn>
                                </ActionSection>

                                {/* Transfer Method Selection Modal */}
                                <SelectOptionModal
                                    isOpen={isMethodModalOpen}
                                    onClose={() => setIsMethodModalOpen(false)}
                                    title="Select Transfer Method"
                                    options={transferMethodOptions}
                                    selectedValue={values.transferMethod}
                                    onSelect={handleTransferMethodSelect}
                                    searchPlaceholder="Search transfer methods..."
                                />

                                {/* Account Selection Modal */}
                                <SelectItemModal
                                    isOpen={isAccountModalOpen}
                                    onClose={() => setIsAccountModalOpen(false)}
                                    onSelect={handleBeneficiarySelect}
                                    options={formattedAccounts}
                                    selectedItem={selectedBeneficiary}
                                    title="Select Beneficiary Account"
                                    searchPlaceholder="Search by name, account number, or mobile..."
                                    idKey="id"
                                    nameKey="displayName"
                                    descriptionKeys={["displayDescription"]}
                                    emptyMessage="No beneficiary accounts available"
                                    noResultsMessage="No matching accounts found"
                                />
                            </Form>
                        )
                    }}
                </Formik>
            </div>
        </Container>
    );
};

// Styled components
const Container = tw.div`bg-white w-full h-full flex flex-col relative`;
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`;
const FieldWrapper = tw.div`w-full`;
const OptionCard = tw.button`
  flex flex-col items-center justify-center p-3 rounded-lg shadow border border-gray-200 text-center
  cursor-pointer transition-all duration-200 
  ${(props) =>
        props.isselected === "true"
            ? "bg-primary-color/10 border-primary-color"
            : "bg-white hover:bg-gray-50"}
`;
const Textarea = tw.textarea`min-h-30 border border-gray-300 rounded pl-2 py-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200 w-full h-30 resize-y break-words overflow-hidden`;
const UserInfo = tw.div`flex flex-col`;
const ProfileSection = tw.div`flex items-center gap-3 bg-gray-100 px-4 p-4`;
const ErrorText = tw.div`text-red-500 text-sm mt-1`;
const Text = tw.p`text-gray-500 text-xs font-normal `;
export default MarkAsPaidOnlineModal;